import { render, staticRenderFns } from "./DashboardPemohon.vue?vue&type=template&id=32823bb7&"
import script from "./DashboardPemohon.vue?vue&type=script&lang=js&"
export * from "./DashboardPemohon.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports